export enum InputType {
    Select = 'Select',
    AutoComplete = 'AutoComplete',
    AutoCompleteMultiple = 'AutoComplete Multiple',
    TextField = 'TextField',
    Checkbox = 'Checkbox',
    Slider = 'Slider'
}